export const lineColorExpression = (paint = {}) => {
  if (paint.lineColorField && paint.lineColorStops) {
    const stops = paint.lineColorStops.flat()
    return ['interpolate', ['linear'], ['coalesce', ['to-number', ['get', paint.lineColorField]], 0], ...stops]
  }

  if (!paint.lineColorField || !paint.lineColors) return paint.lineColor || paint.fillColor || '#0f766e'

  const matchPairs = Object.entries(paint.lineColors).flatMap(([value, color]) => [value, color])
  return ['match', ['to-string', ['get', paint.lineColorField]], ...matchPairs, paint.lineColor || '#0f766e']
}

export const lineWidthExpression = (paint = {}) => {
  if (!paint.lineWidthField || !paint.lineWidthStops) return paint.lineWidth || 2

  const stops = paint.lineWidthStops.flat()
  return ['interpolate', ['linear'], ['coalesce', ['to-number', ['get', paint.lineWidthField]], 0], ...stops]
}
